import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {SettingsSmsService} from '../../../services/settings-sms.service';

declare const $: any;

@Component({
    selector: 'settings-sms-list',
    templateUrl: './settings-sms-list.component.html',
    styleUrls: ['./settings-sms-list.component.scss']
})
export class SettingsSmsListComponent {

    constructor(
        public urlService: UrlService,
        public settingsSmsService: SettingsSmsService
    ) {}

    toggleCheck(selectedItem): void {
        if (selectedItem.checked && this.settingsSmsService.selectedItemData)
            this.settingsSmsService.toggleDetailedView(null, false);
        else
            this.settingsSmsService.toggleDetailedView(selectedItem, true);
    }

    showHint(e) {
        e.stopPropagation();
        const $td = $(e.target).closest('.table-hint-td');
        if ($td.hasClass('active'))
            $td.removeClass('active');
        else {
            $('.table-hint-td').removeClass('active');
            $td.addClass('active');
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-sms/settings-sms-list/settings-sms-list.component.ts